import React from "react";
import SectionHeading from "./sectionHeading";

export default function LeadershipFeature({ content }) {
  return (
    <div id="leadershipFeature">
      <SectionHeading subtitle={content.subtitle} title={content.title} />
      <div className="wrapper">
        {content.list &&
          content.list.length > 0 &&
          content.list.map((item, index) => (
            <div key={index} className="item">
              <img src={item.image.url} alt="" />
              <div className="text-wrapper">
                <div className="header">{item.title}</div>
                <div className="description" dangerouslySetInnerHTML={{ __html: item.content }} />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
